export const REGEX = {
  GLOBAL: {
    NOT_HAS_SPECIAL_CHARS: /^[a-zA-ZÀ-ÿ0-9 ]*$/,
    NOT_HAS_DOUBLE_SPACES: /^(?!.* {2,}).*$/
  },

  PRIMITIVES: {
    STRING: {
      ONLY_CHARS: /^[a-zA-ZÀ-ÿ]+$/,
      ONLY_CHARS_WITH_SPACES: /^[a-zA-ZÀ-ÿ ]+$/
    },

    NUMBER: {
      ONLY_NUMBERS: /^[0-9]+$/,
      ONLY_NUMBERS_WITH_SPACES: /^[0-9 ]+$/
    }
  },

  CEP: /^[0-9]{8}$|^[0-9]{5}-[0-9]{3}$/,
  CNPJ: /^[0-9]{14}$|^[0-9]{2}\.[0-9]{3}\.[0-9]{3}\/[0-9]{4}-[0-9]{2}$/,
  CPF: /^\d{3}\.\d{3}\.\d{3}-\d{2}$|^\d{11}$/,
  CPF_OR_CNPJ: /^(\d{3}\.\d{3}\.\d{3}-\d{2}|\d{11}|\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}|\d{14})$/,
  PLATE: /^[A-Z]{3}(?:[0-9]{4}|[0-9][A-Z][0-9]{2})$/,
  RENAVAM: /^[0-9]{11}$|^[0-9]{9}-[0-9]{2}$/,
  PHONE: /^\(\d{2}\) 9 ?\d{4}-\d{4}$/,
  CNH: /^[0-9]{11}$/
};
